// Legacy generators are synchronous and use Math.random. Restore it even when
// generation fails; never keep the replacement across a render or async call.
export function withTaskSeed(seed, generate) {
  let state = 2166136261;
  for (const char of String(seed)) state = Math.imul(state ^ char.charCodeAt(0), 16777619);
  const previous = Math.random;
  Math.random = () => {
    state += 0x6D2B79F5;
    let value = Math.imul(state ^ (state >>> 15), state | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
  try { return generate(); } finally { Math.random = previous; }
}
